<!-- Background design with image and color overlays -->
<img class="global-background" src="assets/images/backgroundImage.jpg" alt=""/>
<div class="global-background-overlay"></div>
<div class="global-background-overlay-lighter"></div>

<!-- Header -->
<app-header></app-header>


<!-- View with fotter at the bottom and each page with a minimum of 100vh -->
<div class="global-background-div">
    <router-outlet class="content-wrapper"></router-outlet>
    <app-footer class="app-footer"></app-footer>
</div>


<!-- Settings buttom at the right bottom corner -->
<button mat-fab class="fixed-button" (click)="openSettings()">
    <mat-icon>settings</mat-icon>
</button>